import { Flex } from '@assets/component/UI/Flex/Flex';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { NarrativeStore, SupportingFact } from '@assets/model/NarrativeStore';
import { SideChatMessage } from '@assets/model/SideChatStore';
import { useStore, useStoreUI } from '@assets/model/Store';
import { formatDivMarkup } from '@assets/utils/CompUtils';
import classNames from 'classnames';
import { get, ref, set } from 'firebase/database';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import FlLogo from '../FlightlineChatLogo.svg';
import * as style from './AttachFacts.module.less';
import { MessageReasoningFooter } from '../shared/MessageReasoningFooter';

interface AttachFactsMessageProps {
    message: SideChatMessage;
    narStore: NarrativeStore;
}

const AttachFactsMessage = observer((p: AttachFactsMessageProps) => {
    const { message: m } = p;
    const [currentIndex, setCurrentIndex] = useState(0);

    if (!m) {
        return <div>RecommendL3 Message: Missing Message</div>;
    }

    const list = m.content as SupportingFact[];

    if (!list || currentIndex >= list.length) {
        return <div>RecommendL3 Message: Index Error</div>;
    }
    const onClickNext = () => {
        setCurrentIndex((currentIndex + 1) % list.length);
    };

    const onAddFact = async (entry: SupportingFact) => {
        const store = useStore();
        const path = `/narrative/${store.selectedReportId}/facts_index/${p.message.chatContext}/supporting_facts`;

        const fb = getFirebase();
        const r = ref(fb.db, path);
        const snapshot = await get(r);
        const list = snapshot.val();
        let insertIndex = 0;
        if (list) {
            insertIndex = list.length;
        }
        const insertPath = `${path}/${insertIndex}`;
        const r_insert = ref(fb.db, insertPath);
        set(r_insert, toJS(entry));
        console.log(insertIndex);
    };

    const buildFactEl = (entry: SupportingFact) => {
        return (
            <div className={style.l4Grid} style={{ position: 'relative' }}>
                <div className={classNames('item', style.l4_header)}>
                    <Flex>
                        <div style={{ flex: 1 }}>
                            ACTION: Add Supporting Fact
                        </div>
                        <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                onClickNext();
                            }}
                        >
                            {currentIndex + 1}/{list.length}
                            <i className="bi bi-chevron-double-right"></i>
                        </div>
                    </Flex>
                </div>

                <div className={classNames('item', style.l4_text)}>
                    {formatDivMarkup(entry.exact_fact_quote)}
                </div>
                <div className={classNames('item', style.cta_button)}>
                    <Button
                        variant="light"
                        className={style.denyButton}
                        onClick={() => {
                            onClickNext();
                        }}
                    >
                        <i className="bi bi-x"></i>
                        Discard
                    </Button>
                    <Button
                        variant="light"
                        className={style.approveButton}
                        onClick={() => {
                            onAddFact(entry);
                        }}
                    >
                        <i className="bi bi-check"></i>
                        Approve
                    </Button>
                </div>
                <MessageReasoningFooter m={m}>
                    {entry.logical_connection}
                    <br></br>
                    <br></br>
                    <b>Source:</b> {entry.fact_citation_source_file}
                    <br></br>
                    {entry.exact_fact_quote}
                </MessageReasoningFooter>
            </div>
        );
    };

    const currentFact = list[currentIndex];

    return (
        <Flex style={{ width: '100%' }}>
            <div className={style.logoBackgroundBase}>
                <img src={FlLogo}></img>
            </div>
            {buildFactEl(currentFact)}
        </Flex>
    );
});

export default AttachFactsMessage;
